import { Link, useLocation, useResolvedPath } from 'react-router-dom';
import styled from 'styled-components';

const StyledSideNav = styled.nav`
  width: 250px;
  height: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
`;

const StyledButtons = styled(Link)<{ active?: boolean }>`
  width: fit-content;
  margin-bottom: 16px;
  background-color: inherit;
  font-size: 1.125rem;
  color: rgb(100, 112, 125);
  text-decoration: none;
  font-family: inherit;
  :hover {
    cursor: pointer;
    color: rgb(18, 18, 19);
  }
  border-bottom: ${props => props.active && 'solid blue 2px'};
  color: ${props => props.active && 'rgb(18, 18, 19);'};
`;

const SideNav = () => {
  const location = useLocation();

  return (
    <StyledSideNav>
      <StyledButtons
        to="connector/list"
        data-testid="connectors-dashboard-button"
        active={location.pathname.includes('connector')}
      >
        Connectors
      </StyledButtons>
      <StyledButtons
        to="api/list"
        data-testid="integrations-dashboard-button"
        active={location.pathname.includes('api')}
      >
        APIs
      </StyledButtons>
      <StyledButtons
        to="explorer"
        data-testid="explorer-dashboard-button"
        active={location.pathname.includes('explorer')}
      >
        Explorer
      </StyledButtons>

      <StyledButtons
        to="schema"
        data-testid="schema-dashboard-button"
        active={location.pathname.includes('schema')}
      >
        Schema
      </StyledButtons>
      <StyledButtons
        to="testing"
        data-testid="testing-dashboard-button"
        active={location.pathname.includes('testing')}
      >
        Testing
      </StyledButtons>
    </StyledSideNav>
  );
};

export default SideNav;
